/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { AutoForecastPolicySetting } from './autoForecastPolicySetting';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/auto-forecast-setting-detail-items';

export const AutoForecastSettingDetailItemApi = {
  findEntityProposalPolicyForUpdate: async (
    option: FindEntityPolicyForUpdate
  ) => {
    let url = `${pathname}/find-entity-proposal-policy`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (data: CreateMultiAutoForecastSettingDetailItemBody) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateAutoForecastSettingDetailItemBody) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (data: CreateAutoForecastSettingDetailItemBody) => {
    try {
      const response = await entityService.post(pathname, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateAutoForecastSettingDetailItemBody {
  autoForecastSettingDetailID: string;
  fromQuantity: string;
  toQuantity: string;
  discount: number;
  type: number;
  quantityPolicySettings: Array<{
    entityProposalPolicyID?: string;
    entityPricePolicyID?: string;
  }>;
}

export interface CreateMultiAutoForecastSettingDetailItemBody {
  autoForecastSettingDetailItems: CreateAutoForecastSettingDetailItemBody[];
}

export interface UpdateAutoForecastSettingDetailItemBody {
  fromQuantity?: string | null;
  toQuantity?: string | null;
}

export type AutoForecastSettingDetailItem = {
  id: string;
  autoForecastSettingDetailID: string;
  fromQuantity?: string;
  toQuantity?: string;
  discount?: number;
  status?: number;
  createdAt?: string;
  updatedAt?: string;
  type?: number;
  autoForecastPolicySettings: AutoForecastPolicySetting[];
};

export type FindEntityPolicyForUpdate = {
  page: number;
  take: number;
  policyType: 'PROPOSAL_POLICY' | 'PRICE_POLICY';
  name?: string;
  status?: string;
  reserved?: boolean;
  order?: any;
};
